import React from 'react';
import { Avatar } from '@icon-park/react';

/**
 * ProfileSidebar - 用户配置左侧边栏
 */
export function ProfileSidebar({ username, activeTab, onTabChange, onLogout }) {
  const handleLogoutClick = () => {
    if (window.confirm('确定要退出登录吗？')) {
      onLogout && onLogout();
    }
  };

  return (
    <aside className="profile-sidebar">
      <div className="user-avatar-section">
        <div className="user-avatar">
          <span className="avatar-icon">
            <Avatar theme="outline" size={24} fill="#94a3b8" strokeWidth={3} />
          </span>
        </div>
        <div className="username">{username || '未命名用户'}</div>
      </div>

      <nav className="profile-nav">
        <button 
          className={`nav-item ${activeTab === 'profile' ? 'active' : ''}`}
          onClick={() => onTabChange('profile')}
        >
          个人中心
        </button>
        <button 
          className={`nav-item ${activeTab === 'myLabels' ? 'active' : ''}`}
          onClick={() => onTabChange('myLabels')}
        >
          我的创建
        </button>
        <button 
          className={`nav-item ${activeTab === 'edit' ? 'active' : ''}`}
          onClick={() => onTabChange('edit')}
        >
          修改信息
        </button>
        <button 
          className="nav-item logout"
          onClick={handleLogoutClick}
        >
          退出登录
        </button>
      </nav>
    </aside>
  );
}
